import React, { Fragment, useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  Box,
  MenuItem,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  updateEndorsementFormData,
  selectEndorsmentFormData,
} from "src/features/rfqDataSlice";
import request from '../../../../utils/request';

const HypotheticalDetailsEditable = () => {
  const dispatch = useDispatch();
  const [bankData, setBankData] = useState<any[]>([]);
  useEffect(() => {
    getBankData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getBankData = async () => {
    request({
      url: 'bank/getBankList',
      method: 'post',
      data: {

        orderColumn: 'name',
        orderDirection: 'ASC',
        offset: 0,
        limit: 10000,
        status: true
      }
    }).then(
      (response) => {
        setBankData([]);
        setBankData(response['bankData']);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  const endorsementFormData = useSelector(selectEndorsmentFormData);

  const allRows = endorsementFormData?.hypothetical_details || [];

  // Only show update rows
  const rows = allRows
    .map((item, index) => ({ ...item, originalIndex: index }))
    .filter((item) => item.action_type === "update");

  if (!rows.length) return null;

  const handleChange = (originalIndex, field, value) => {
    const updated = [...allRows];

    updated[originalIndex] = {
      ...updated[originalIndex],
      newValue: {
        ...updated[originalIndex].newValue,
        [field]: value,
      },
    };

    dispatch(
      updateEndorsementFormData({
        ...endorsementFormData,
        hypothetical_details: updated,
      })
    );
  };

  return (
    <>
      <Box sx={{ mb: 1, mt: 1 }}>
        <Typography
          variant="h5"
          sx={{
            background: "rgb(9 84 174)",
            color: "#fff",
            py: 1,
            fontWeight: "bold",
            pl: 2,
          }}
        >
          Hypothecation Details
        </Typography>
      </Box>

      {rows.map((row) => (
        <Grid
          container
          spacing={2}
          key={row.originalIndex}
          sx={{ mb: 3 }}
        >
          {/* Field Label */}
          <Grid item xs={4}>
            <Typography fontWeight="bold">
              Field
            </Typography>
            <Typography>Bank / Branch</Typography>
          </Grid>

          {/* Old Value */}
          <Grid item xs={4}>
            <Typography
              fontWeight="bold"
              sx={{ color: "red" }}
            >
              Old Value
            </Typography>
            <Typography>
              {row.bank} - {row.branch}
            </Typography>
          </Grid>

          {/* New Value */}
          <Grid item xs={4}>
            <Typography
              fontWeight="bold"
              sx={{ color: "green" }}
            >
              New Value
            </Typography>



            <TextField
              size="small"
              select
              label={
                <Fragment>
                  Bank{' '}
                  {/* <Typography component="span" sx={{ color: 'red' }}>
                                  *
                                </Typography> */}
                </Fragment>
              }

              fullWidth
              value={row?.newValue?.bank || ""}
              onChange={(e) =>
                handleChange(
                  row.originalIndex,
                  "bank",
                  e.target.value
                )
              }

            >
              {bankData.map((bank) => (
                <MenuItem key={bank.id} value={bank.name}>
                  {bank.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              fullWidth
              size="small"
              label="Branch"
              value={row?.newValue?.branch || ""}
              onChange={(e) =>
                handleChange(
                  row.originalIndex,
                  "branch",
                  e.target.value
                )
              }
            />
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default HypotheticalDetailsEditable;
